import { render, staticRenderFns } from "./FeideLogin.vue?vue&type=template&id=59aadd32"
import script from "./FeideLogin.vue?vue&type=script&lang=js"
export * from "./FeideLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports